module.exports = __webpack_public_path__ + "static/media/10.ea8b12e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/10.png
// module id = 791
// module chunks = 0